import { useNavigate } from "react-router-dom";
import { urls } from "../../urls";

export const useProjectNavigation = () => {
  const navigate = useNavigate();
  return (projectId: string) => {
    navigate(urls.app.projects.view.go(projectId));
  };
};
